import { ForecastService } from '@navio/nsdk';
import { useDateRangePickerQueryParam, useNoddiQueryParam } from 'noddi-ui-web';
import { ArrayParam, createEnumParam, StringParam, withDefault } from 'use-query-params';

const comparisonParam = createEnumParam(['yoy', 'prior', 'none']);
const customerParam = createEnumParam(['all', 'b2c', 'b2b']);
const granularityParam = createEnumParam(['day', 'week', 'month']);
const metricParam = createEnumParam(['bookings', 'cars', 'revenue', 'revenue-per-car']);

/** Selection remains in the partner department store; this hook owns only shareable view filters. */
export const useForecastFilters = () => {
  const dates = useDateRangePickerQueryParam();
  const [service, setService] = useNoddiQueryParam(
    'service',
    withDefault(createEnumParam<ForecastService>(Object.values(ForecastService)), 'tire_change')
  );
  const [categories, setCategories] = useNoddiQueryParam('service-categories', withDefault(ArrayParam, []));
  const [memberships, setMemberships] = useNoddiQueryParam('membership-programs', withDefault(ArrayParam, []));
  const [comparison, setComparison] = useNoddiQueryParam('comparison', withDefault(comparisonParam, 'yoy'));
  const [customerType, setCustomerType] = useNoddiQueryParam('customer-type', withDefault(customerParam, 'all'));
  const [granularity, setGranularity] = useNoddiQueryParam('granularity', withDefault(granularityParam, 'week'));
  const [metric, setMetric] = useNoddiQueryParam('metric', withDefault(metricParam, 'bookings'));
  const [focus, setFocus] = useNoddiQueryParam('focus', StringParam);
  return {
    ...dates,
    service: service ?? ForecastService.TIRE_CHANGE,
    setService,
    categories,
    setCategories,
    memberships,
    setMemberships,
    comparison: comparison ?? 'yoy',
    setComparison,
    customerType: customerType ?? 'all',
    setCustomerType,
    granularity: granularity ?? 'week',
    setGranularity,
    metric,
    setMetric,
    focus,
    setFocus
  };
};
